
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Layout from "../components/Layout";
import useTranslation from "next-translate/useTranslation";

import { Flex, Box } from "rebass/styled-components";
import AccountType from "../components/signup/AccountType";
import SignupForm from "../components/signup/SignupForm";
import { withoutAuth } from "../lib/auth";
import { UserType } from "../enums";

const types = {
  user: UserType.USER,
  caregiver: UserType.CAREGIVER
};

interface Props {
  query: Record<string, any>;
}

function Signup({ query }: Props) {
  const { t } = useTranslation("signup");

  let type = Object.values(types).filter(type => type === query.type);

  return (
    <Layout withTransparentHeader immersive title={t("title")}>
      <Flex alignItems="center" height={["auto", "100vh"]} variant="dogHair">
        {!type.length ? (
          <Box variant="layout.medium">
            <AccountType types={types} />
          </Box>
        ) : (
          <Box variant="layout.small">
            <SignupForm account={type.pop()} redirectParams={query} />
          </Box>
        )}
      </Flex>
    </Layout>
  );
}

 const _getServerSideProps = withoutAuth()(async ({ query }) => {
  return { props: { query } };
});

export default Signup;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/signup',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  